<template>
  <div>
    <div v-for="(item, index) in data" :key="index">
        <!-- {{item.model}} -->
        <template v-if="item.model === 1">
            <patch1 :val="item"/>
        </template>
        <template v-if="item.model === 2">
            <patch2 :val="item"/>
        </template>
        <template v-if="item.model === 3">
            <patch3 :val="item"/>
        </template>
        <template v-if="item.model === 4">
            <patch4 :val="item"/>
        </template>
        <template v-if="item.model === 5">
            <patch5 :val="item"/>
        </template>
        <template v-if="item.model === 6">
            <patch6 :val="item"/>
        </template>
        <template v-if="item.model === 7">
            <patch7 :val="item"/>
        </template>
        <template v-if="item.model === 8">
            <patch8 :val="item"/>
        </template>
        <template v-if="item.model === 9">
            <patch9 :val="item"/>
        </template>
        <template v-if="item.model === 10">
            <patch10 :val="item"/>
        </template>
        <template v-if="item.model === 11">
            <patch11 :val="item"/>
        </template>
        <template v-if="item.model === 12">
            <patch12 :val="item"/>
        </template>
        <template v-if="item.model === 13">
            <patch13 :val="item"/>
        </template>
        <template v-if="item.model === 14">
            <patch14 :val="item"/>
        </template>
        <template v-if="item.model === 15">
            <patch15 :val="item"/>
        </template>
        <template v-if="item.model === 16">
            <patch16 :val="item"/>
        </template>
        <template v-if="item.model === 17">
            <patch17 :val="item"/>
        </template>
        <template v-if="item.model === 18">
            <patch18 :val="item"/>
        </template>
        <template v-if="item.model === 19">
            <patch19 :val="item"/>
        </template>
        <template v-if="item.model === 20">
            <patch20 :val="item"/>
        </template>
        <template v-if="item.model === 21">
            <patch21 :val="item"/>
        </template>
        <template v-if="item.model === 22">
            <patch22 :val="item"/>
        </template>
        <template v-if="item.model === 23">
            <patch23 :val="item"/>
        </template>
        <template v-if="item.model === 24">
            <patch24 :val="item"/>
        </template>
        <template v-if="item.model === 25">
            <patch25 :val="item"/>
        </template>
        <template v-if="item.model === 26">
            <patch26 :val="item"/>
        </template>
        <template v-if="item.model === 27">
            <patch27 :val="item"/>
        </template>
        <template v-if="item.model === 28">
            <patch28 :val="item"/>
        </template>
        <template v-if="item.model === 29">
            <patch29 :val="item"/>
        </template>
        <template v-if="item.model === 30">
            <patch30 :val="item"/>
        </template>
        <template v-if="item.model === 31">
            <patch31 :val="item"/>
        </template>
        <template v-if="item.model === 32">
            <patch32 :val="item"/>
        </template>
        <template v-if="item.model === 33">
            <patch33 :val="item"/>
        </template>

    </div>
  </div>
</template>

<script>
import Patch1 from '@/components/item/patch1.vue';
import Patch2 from '@/components/item/patch2.vue';
import Patch3 from '@/components/item/patch3.vue';
import Patch4 from '@/components/item/patch4.vue';
import Patch5 from '@/components/item/patch5.vue';
import Patch6 from '@/components/item/patch6.vue';
import Patch7 from '@/components/item/patch7.vue';
import Patch8 from '@/components/item/patch8.vue';
import Patch9 from '@/components/item/patch9.vue';
import Patch10 from '@/components/item/patch10.vue';
import Patch11 from '@/components/item/patch11.vue';
import Patch12 from '@/components/item/patch12.vue';
import Patch13 from '@/components/item/patch13.vue';
import Patch14 from '@/components/item/patch14.vue';
import Patch15 from '@/components/item/patch15.vue';
import Patch16 from '@/components/item/patch16.vue';
import Patch17 from '@/components/item/patch17.vue';
import Patch18 from '@/components/item/patch18.vue';
import Patch19 from '@/components/item/patch19.vue';
import Patch20 from '@/components/item/patch20.vue';
import Patch21 from '@/components/item/patch21.vue';
import Patch22 from '@/components/item/patch22.vue';
import patch23 from '@/components/item/patch23.vue';
import Patch24 from '@/components/item/patch24.vue';
import Patch25 from '@/components/item/patch25.vue';
import Patch26 from '@/components/item/patch26.vue';
import Patch27 from '@/components/item/patch27.vue';
import Patch28 from '@/components/item/patch28.vue';
import Patch29 from '@/components/item/patch29.vue';
import Patch30 from '@/components/item/patch30.vue';
import Patch31 from '@/components/item/patch31.vue';
import Patch32 from '@/components/item/patch32.vue';
import Patch33 from '@/components/item/patch33.vue';
export default {
  components: {
      Patch1,
      Patch2,
      Patch3,
      Patch4,
      Patch5,
      Patch6,
      Patch7,
      Patch8,
      Patch9,
      Patch10,
      Patch11,
      Patch12,
      Patch13,
      Patch14,
      Patch15,
      Patch16,
      Patch17,
      Patch18,
      Patch19,
      Patch20,
      Patch21,
      Patch22,
      patch23,
      Patch24,
      Patch25,
      Patch26,
      Patch27,
      Patch28,
      Patch29,
      Patch30,
      Patch31,
      Patch32,
      Patch33,

  },
  props: {
    data: []
  },
  data() {
      return{
      }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/components/patch.vue